import { getItemHighlight, getSecondaryHighlight } from "./utils";

export function getRentalTemplate(item, html) {
  return html` <div class="aa-ItemWrapper">
    <div class="aa-ItemContent">
      <div class="aa-ItemIcon aa-ItemIcon--alignTop">
        <svg
          aria-hidden="true"
          focusable="false"
          data-prefix="fas"
          data-icon="laptop-mobile"
          class="svg-inline--fa fa-laptop-mobile "
          role="img"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 640 512"
          height="24"
          width="24"
        >
          <path
            fill="currentColor"
            d="M128 0C92.7 0 64 28.7 64 64V288H19.2C8.6 288 0 296.6 0 307.2C0 349.6 34.4 384 76.8 384H352V288H128V64H448V96h64V64c0-35.3-28.7-64-64-64H128zM448 448V192H576V448H448zM384 176V464c0 26.5 21.5 48 48 48H592c26.5 0 48-21.5 48-48V176c0-26.5-21.5-48-48-48H432c-26.5 0-48 21.5-48 48z"
          ></path>
        </svg>
      </div>
      <div class="aa-ItemContentBody">
        <div class="aa-ItemContentTitle">
          ${getItemHighlight(
            html,
            item,
            "rental.stocklist_item.name",
            "no device"
          )}
          <!-- <span class="gsid text-success">ID: ${item.document
            .id}</span> -->
        </div>
        <div class="aa-ItemContentDescription">
          ${getSecondaryHighlight(html, item, "employee.email")}
          <span class="orgid label label-default"
            >Org ID: ${item.document["rental.organisation_id"]}</span
          >
          <span class="text-danger ml-1">
            (${item.document["rental.organisation_name"]})</span
          >
        </div>
      </div>
    </div>
  </div>`;
}
